module.exports = __webpack_public_path__ + "static/media/cancel_black.6a767c52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/svg/cancel_black.svg
// module id = 1284
// module chunks = 0